import { render, staticRenderFns } from "./NationalityListItem.vue?vue&type=template&id=18cbdef6&scoped=true"
import script from "./NationalityListItem.vue?vue&type=script&lang=js"
export * from "./NationalityListItem.vue?vue&type=script&lang=js"
import style0 from "./NationalityListItem.vue?vue&type=style&index=0&id=18cbdef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbdef6",
  null
  
)

export default component.exports